import { enqueueSnackbar } from 'notistack';

export default async function copyToClipboard(textToCopy: string, toastMessage: string) {
  try {
    await navigator.clipboard.writeText(textToCopy);
    enqueueSnackbar(toastMessage, {
      variant: 'success',
      autoHideDuration: 5000
    });
  } catch (err) {
    console.error(err);
  }
}
